import { Contract, HOUR } from '@atomica.co/irori';

export const isTimeBasedPlan = (contract: Contract | undefined): boolean => {
  if (!contract) return false;
  return contract.contractPlan.includes(HOUR);
};
